<template>
  <div class="mtitle">
    <div :class="item.path == $route.path ? 'title isclick' : 'title'" v-for="(item, index) in titleListNew"
      :key="item.path" @mousedown="mousedown(item.name, $event)" :ref="item.name">
      <div class="link" @click="jumpPage(item.path)">{{ item.name }}</div>
      <!-- <i class="el-icon-circle-close" v-if="titleListNew.length != 1" @click="deltitleItem(index)"></i> -->
      <i class="el-icon-circle-close" v-if="item.name !== '首页'" @click="deltitleItem(index)"></i>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
export default {
  inject: ["changerefresh"],
  props: ["titlelist"],
  data() {
    return {
      timeout: null,
    };
  },
  computed: {
    ...mapState(["titleListNew"]),
  },
  methods: {
    ...mapMutations(["delTitleList"]),
    jumpPage(path) {
      if (path && this.$route.path != path) this.$router.push(path);
      this.changerefresh();
    },
    mousedown(name, event) {
      clearTimeout(this.timeout);
      this.timeout = setTimeout((_) => {
        // console.log(this.$refs[name])
        this.$refs[name].style = "cursor:move";
      }, 1000);
    },
    deltitleItem(index) {
      try {
        if (this.$route.path == this.titleListNew[index].path) {
          this.$router.push(this.titleListNew[index - 1].path)
        }
        this.delTitleList(index);
      } catch (error) {
        console.log(error, "error");
      }

    },
  },
};
</script>
<style lang="scss" scoped>
.mtitle {
  line-height: 42px;
  font-size: 80%;
  color: #17B6A1;
  background: #F5F6FA;

  .link {
    cursor: inherit;
    text-decoration: none;
    // color: #17B6A1;
  }

  .navtitle_span {
    margin-right: 1%;
    vertical-align: middle;
  }

  .title {
    position: relative;
    display: inline-block;
    // width: 100px;
    padding: 0 15px;
    text-align: center;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    margin: 0 2px;
    vertical-align: middle;
    box-shadow: 0 2px 3px 0px #F5F6FA;
    cursor: default;
    transition: 600ms;

    &:hover {
      // background-color: #17B6A1;
        background-color:lighten(#17B6A1,5%);

      cursor: pointer;

      .link {
        color: #ffffff;
      }
    }

    .el-icon-circle-close {
      display: none;
      position: absolute;
      top: 0;
      right: 0;
      font-size: 15px;
      cursor: pointer;
    }

    &:hover .el-icon-circle-close {
      display: inline-block;
      color: rgb(255, 255, 255);
    }
  }

  .isclick {
    box-shadow: 0 2px 3px 0px #b0afaf, 0 0 3px 0px #17B6A1 inset;
    background-color: #17B6A1;
    color: #ffffff !important;
  }
}
</style>